// src/components/Footer.js
import React from 'react';
import '../styles/Footer.css';
import '../styles/Root.css';
import ancre from '../assets/ancres/ancre1.png'

const Footer = () => {
  return (
    <footer className="footer-tdm">
      <div className="footer-container">
        <div className="footer-main">
          <img src={ancre} alt="Logo Musée des Troupes de Marine" className="footer-logo" />
          <address className="footer-contact">
            <p style={{ color: 'var(--tdm-yellow)' }}>Musée des Troupes de Marine</p>
            <p>240 Avenue du Musée des Troupes de Marine</p>
            <p>83600 Fréjus</p>
            <p>Tél : 04 94 17 86 03</p>
          </address>
          <div className="footer-section">
            <h3 className="footer-title">Le Musée</h3>
            <ul className="footer-links">
              <li><a href="/pages/lemuseeenbref">Le musée en bref</a></li>
              <li><a href="/pages/sescollections">Ses collections</a></li>
              <li><a href="/pages/lechetom">Le CHETOM / Archives</a></li>
              <li><a href="/pages/travailleraumusee">Travailler au musée</a></li>
              <li><a href="/pages/nospartenaires">Nos Partenaires</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3 className="footer-title">Renseignements</h3>
            <ul className="footer-links">
              <li><a href="/pages/informationspratiques">Informations pratiques</a></li>
              <li><a href="/pages/visiteguidee">Demander une visite</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3 className="footer-title">Liens utiles</h3>
            <ul className="footer-links">
              <li><a href="/pages/laboutique">Boutique du musée</a></li>
              <li><a href="/pages/sesmissions">Les Amis du Musée</a></li>
              <li><a href="/pages/formulairescontact">Contact</a></li>
              <li><a href="/pages/Informationslegales">Mentions légales</a></li>
              <li><a href="/pages/cgv">Conditions générales de vente</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-social">
            <a href="#" className="social-link" aria-label="Facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="#" className="social-link" aria-label="Twitter">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#" className="social-link" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
          <p className="footer-copyright">© 2024 Musée des Troupes de Marine. Tous droits réservés.</p>
          <p className="footer-developed-by">Site développé par <a href="https://back2growth.fr" className="back2growth-link">Back2Growth EURL</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
